import { detectBrandFromHostname, getBrandConfig, isAnonymousBrand } from '@cannect/config/brands.config'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { HomeUI } from './HomeUI'
import { useHome } from './useHome'

export const HomePage = () => {
  const history = useHistory()
  const props = useHome()

  useEffect(() => {
    const isAspaecHome =
      window.location.hostname === 'sistema.aspaec.com' &&
      (window.location.pathname === '/' || window.location.pathname === '')
    if (isAspaecHome) {
      history.replace('/AreaAssociados')
      return
    }
    // Domínio próprio de marca sem login (vikura.com.br, remederi...): a raiz
    // é a jornada da marca, não a home da Cannect. Só pelo hostname — em
    // cannect.life a home continua a da Cannect.
    const hostBrand = detectBrandFromHostname(window.location.hostname)
    const brandSchedulingPath = getBrandConfig(hostBrand).scheduling.path
    if (isAnonymousBrand(hostBrand) && brandSchedulingPath) {
      history.replace(brandSchedulingPath)
    }
  }, [history])

  return <HomeUI {...props} />
}
